module.exports = __webpack_public_path__ + "media/images/pepsi_digin_day/celebrate-icon-8b061b7c678a9eab58b7adc98bfc1b36.png";